module.exports = __webpack_public_path__ + "resources/img/img_plantpulse_en.edf9a20a6619628b08bde021b6e3899d.png";